import React from "react";
import FormTemplate from "@/components/templates/FormTemplate.jsx";
import WizReportForm from "@/components/organisms/WizReportForm.jsx";
import UnderConstruction from "@/components/molecules/UnderConstruction.jsx";

function WIZ() {
  return (
    <FormTemplate title="WIZ">
      {/* <WizReportForm /> */}
      <UnderConstruction title="WIZ" />
    </FormTemplate>
  );
}

export default WIZ;
